export const IconVDots = ({ scheme }: { scheme: "dark" | "light" }) => {
	const color = scheme === "light" ? "#373948" : "#FFFFFF";

	return (
		<svg
			width="23"
			height="18"
			viewBox="0 0 23 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="10" y="0.5" width="3" height="3" fill={color} />
			<rect x="10" y="7.5" width="3" height="3" fill={color} />
			<rect x="10" y="14.5" width="3" height="3" fill={color} />
		</svg>
	);
};
